import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
export var EVENTS = {
  WHEEL: 'wheel'
};
export function getEventListenerWithBlockedEvents(originalAddEventListener, events) {
  return function customAddEventListener(type, listener, capture) {
    // eslint-disable-next-line no-param-reassign
    events = events || EMPTY_ARRAY;
    if (events.includes(type)) {
      // block specified events
      return;
    }
    this.f = originalAddEventListener;
    this.f(type, listener, capture);
  };
}